import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-center gap-2"
};
import { ref, reactive, computed, watch } from 'vue';
import { useVModel } from '@vueuse/core';
export default {
  __name: 'ProductPicker',
  props: {
    modelValue: {
      type: [String, Array],
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const treeProps = {
      label: 'name',
      children: 'children',
      isLeaf: 'leaf'
    };
    const $props = __props;
    const $emits = __emit;
    const value = useVModel($props, 'modelValue', $emits);
    const productTreeRef = ref();
    const expandedKeys = ref([]);
    const dialogVisible = ref(false);
    const queryForm = reactive({
      name: ''
    });

    // 模拟产品数据，实际应从API获取
    const mockProducts = [{
      id: '1',
      name: '产品A',
      children: [{
        id: '1-1',
        name: '子产品A1'
      }, {
        id: '1-2',
        name: '子产品A2'
      }]
    }, {
      id: '2',
      name: '产品B',
      children: [{
        id: '2-1',
        name: '子产品B1'
      }]
    }, {
      id: '3',
      name: '产品C'
    }];

    // 显示选中的产品名称
    const selectedProductNames = computed(() => {
      if (!value.value || Array.isArray(value.value) && value.value.length === 0) {
        return '';
      }
      const ids = Array.isArray(value.value) ? value.value : [value.value];
      const names = [];
      const findName = nodes => {
        for (const node of nodes) {
          if (ids.includes(node.id)) {
            names.push(node.name);
          }
          if (node.children) {
            findName(node.children);
          }
        }
      };
      findName(mockProducts);
      return names.join(', ');
    });
    watch(() => queryForm.name, val => {
      productTreeRef.value && productTreeRef.value.filter(val);
    });
    const filterNode = (value, data) => {
      if (!value) return true;
      return data.name.includes(value);
    };
    const open = () => {
      dialogVisible.value = true;
      onOpen();
    };
    const onOpen = () => {
      let productIds = [];
      if (Array.isArray(value.value)) {
        productIds.push(...value.value);
      } else if (value.value) {
        productIds.push(value.value);
      }

      // 设置已选中的产品
      if (productIds.length > 0) {
        productTreeRef.value && productTreeRef.value.setCheckedKeys(productIds);
      }
    };
    const onNodeClick = data => {
      if ($props.multiple) {
        const checkedKeys = productTreeRef.value?.getCheckedKeys() || [];
        const index = checkedKeys.indexOf(data.id);
        if (index === -1) {
          checkedKeys.push(data.id);
        } else {
          checkedKeys.splice(index, 1);
        }
        productTreeRef.value?.setCheckedKeys(checkedKeys);
      } else {
        productTreeRef.value?.setCheckedKeys([data.id]);
      }
    };
    const handleConfirm = () => {
      const checkedKeys = productTreeRef.value?.getCheckedKeys() || [];
      if ($props.multiple) {
        value.value = checkedKeys;
      } else {
        value.value = checkedKeys.length > 0 ? checkedKeys[0] : null;
      }
      dialogVisible.value = false;
    };
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_tree = _resolveComponent("el-tree");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_input, {
        modelValue: selectedProductNames.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedProductNames.value = $event),
        readonly: "",
        placeholder: "选择产品",
        onClick: open
      }, {
        append: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: open
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("选择", -1)]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dialogVisible.value = $event),
        onOpen: onOpen,
        "align-center": "",
        title: "选择产品",
        width: "30%"
      }, {
        footer: _withCtx(() => [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: _cache[2] || (_cache[2] = $event => dialogVisible.value = false)
        }, "取消"), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          onClick: handleConfirm
        }, "确认")]),
        default: _withCtx(() => [_createVNode(_component_el_card, {
          shadow: "never",
          class: "product-card"
        }, {
          header: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: queryForm.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => queryForm.name = $event),
            placeholder: "输入关键字进行查询",
            style: {
              width: '100%'
            },
            "suffix-icon": "search",
            clearable: ""
          }, null, 8, ["modelValue"])]),
          default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
            tag: "div",
            class: "product-tree"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tree, {
              ref_key: "productTreeRef",
              ref: productTreeRef,
              data: mockProducts,
              props: treeProps,
              "filter-node-method": filterNode,
              "node-key": "id",
              "show-checkbox": "",
              "default-expanded-keys": expandedKeys.value,
              onNodeClick: onNodeClick
            }, {
              default: _withCtx(({
                data
              }) => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(data.name), 1)])]),
              _: 1
            }, 8, ["default-expanded-keys"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};